import { useEffect, useState } from "react"
import { translations } from "../../../../configs/translations"
import { Language } from "../../../../context/LanguageContext"
import { animNumber } from "../../../../utils/animNumber"
import { formatText } from '../../../../utils/formatText'
import './Awards.css'

export interface Bonus {
    name: string
    amount: number
    isChecked: boolean
}

export interface AwardsProps {
    title: string
    amount: number
    symbol: string
    bonuses: Bonus[]
    totalAmount: number
}

export const Awards = ({ title, amount, symbol, bonuses, totalAmount }: AwardsProps) => {
    const [language, setLanguage] = useState<Language>('ru')
    const t = translations[language]

    const checkboxCheckedSrc = () => {
        return <img className="checkbox-icon" src={"../icons/checkbox_checked.png"} alt="checkbox" />
    }
    const checkboxUncheckedSrc = () => {
        return <img className="checkbox-icon" src={"../icons/checkbox_uncheked.png"} alt="checkbox" />
    }

    const [isFinished, setIsFinished] = useState<boolean>(false)
    useEffect(() => {
        if (!isFinished) {
            setTimeout(() => {
                setIsFinished(true)
            }, 5000)
        }
    }, [])

    const [showAmount, setShowAmount] = useState<number>(0)
    useEffect(() => {
        if (showAmount === amount) return
        const timeout = showAmount === 0 ? 1000 : 0
        setTimeout(() => {
            animNumber(0, amount, 500, setShowAmount)
        }, timeout)
    }, [amount])

    const [showTotalAmount, setShowTotalAmount] = useState<number>(0)
    useEffect(() => {
        if (showTotalAmount === totalAmount) return
        const timeout = showTotalAmount === 0 ? 1000 : 0
        setTimeout(() => {
            animNumber(0, totalAmount, 500, setShowTotalAmount)
        }, timeout)
    }, [totalAmount])

    return (
        <div className="awards">
            <div className={isFinished ? "awards-container-wrapper hide-out" : "awards-container-wrapper"}>
                <div className="awards-container">
                    <div className="awards-title-container">
                        <h1 className="awards-title">{t[title?.toLocaleLowerCase() as keyof typeof t]}</h1>
                    </div>

                    <div className="award-amount-container">
                        <h2 className="award-amount">{showAmount.toFixed(2)} <span className="gold">{symbol}</span></h2>
                    </div>
                    <div className="awards-body">
                        <div className="bonus-title-container">
                            <h2 className="bonus-title">{t.bonus}</h2>
                        </div>

                        <div className="bonus-list">
                            {
                                bonuses && bonuses.map((bonus, index) => (
                                    <div className="bonus-item" key={index}>
                                        <div className="bonus-name-container">
                                            {bonus.isChecked ? checkboxCheckedSrc() : checkboxUncheckedSrc()}
                                            <p className="bonus-name">
                                                {formatText(t[bonus.name as keyof typeof t] || bonus.name, 31)}
                                            </p>
                                        </div>
                                        <div className="bonus-amount-container">
                                            <p className="bonus-amount">{bonus.amount.toFixed(2)} <span className="gold">{symbol}</span></p>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>

                    <div className="total-container">
                        <h2 className="total-title">{t.total}</h2>
                        <h2 className="total-amount">{showTotalAmount.toFixed(2)} <span>{symbol}</span></h2>
                    </div>
                </div>
            </div>
        </div>
    )
}